module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/assessment_achievements/6@2x_2d85eaac27c73f9b28eea0e97ee9dc6d.png";